module.exports = __webpack_public_path__ + "img/jilu.c749a496.jpg";